import { render } from "./ProductsCategories.vue?vue&type=template&id=9dc74532&scoped=true"
import script from "./ProductsCategories.vue?vue&type=script&lang=js"
export * from "./ProductsCategories.vue?vue&type=script&lang=js"

import "./ProductsCategories.vue?vue&type=style&index=0&id=9dc74532&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dc74532"]])

export default __exports__